<template>
  <v-window v-model="tab">
    <v-window-item>
      <list-department ref="tab0"
                       :open-tab="openTab"/>
    </v-window-item>
    <v-window-item>
      <detail-department ref="tab1"
                         :open-tab="openTab"
                         :item="item"/>
    </v-window-item>
    <v-window-item>
      <create-and-update ref="tab2"
                         :open-tab="openTab"
                         :item="item"/>
    </v-window-item>
    <v-window-item>
      <change-password ref="tab3"
                       :open-tab="openTab"
                       :item="item"/>
    </v-window-item>
  </v-window>
</template>

<script>
import ListDepartment from "./List";
import DetailDepartment from "./Detail";
import CreateAndUpdate from "./CreateAndUpdate";
import ChangePassword from "./ChangePassword";

export default {
  name: "DepartmentMain",
  components: {ChangePassword, DetailDepartment, ListDepartment, CreateAndUpdate},
  data() {
    return {
      loading: true,
      item: null,
      tab: 0
    };
  },
  methods: {
    openTab(tab, data) {
      this.tab = tab
      this.item = data
      let t = this.$refs[`tab${tab}`]
      if (t) return t.onTab(this.item)
    }
  }
}
</script>

<style scoped>

</style>